<template>
    <v-combobox
            ref="searchInput"
            auto-select-first
            :menu-props="{ auto: false}"
            outlined
            clearable
            v-model="model"
            :disabled="loadingCreate"
            :items="items"
            :loading="loading || loadingCreate"
            :search-input.sync="search"
            :error-messages="shouldCreate ? 'Antecedente no encontrado' : (errorMessages || null)"
            :filter="() => true"
            color="primary"
            item-text="title"
            item-value="id"
            :label="label || 'Antecedente'"
            @click:clear="clearSearch"
            return-object
    >
        <template slot="no-data">
            <span class="caption pa-2">Ítem no encontrado:
            <v-btn
                    :disabled="!shouldCreate"
                    color="primary"
                    rounded small
                    :loading="loadingCreate"
                    depressed
                    @click="createHistoryItem">crearlo</v-btn>
            </span>
        </template>

        <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-content v-text="data.item.title"></v-list-item-content>
            </template>
        </template>
    </v-combobox>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['value', 'errorMessages', 'medicalHistoryCategoryId', 'label', 'attach'],
        data(){
            return {
                descriptionLimit: 60,
                historyItems: [],
                loading: false,
                loadingCreate: false,

                search: '',
                model: null,
            }
        },
        mounted(){
            this.getItems()
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearSearch(){
                var vm = this
                vm.search = ''
                vm.model = null
                vm.$refs.searchInput.blur()
            },
            async createHistoryItem(){
                var vm =this

                if(vm.search.length < 3){
                    vm.showSnackBar('El motivo debe contener al menos 3 caracteres')
                    return
                }

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                 vm.loadingCreate = true
                const response = await ApiUtils.makePost(`providers/${vm.currentProvider.id}/history/item/create`, {
                    description: vm.search,
                    medical_history_category_id: vm.medicalHistoryCategoryId
                })
                 vm.loadingCreate = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando crear el antecedente')
                    vm.$emit('error', json)
                    return
                }

                const json = await response.json()
                vm.historyItems.push(json.result.item)
                vm.clearSearch()
                vm.$nextTick(async function(){

                    const createdModel = {
                        id: json.result.item.id,
                        title: json.result.item.description,
                    }

                    vm.$emit('change', createdModel)
                    vm.$nextTick(function(){
                        vm.clearSearch()
                    })
                })

            },
            debouncegetItems: debounce(function(){
                this.getItems()
            }, 300),
            async getItems(){

                var vm = this

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                vm.loading = true
                const response = await ApiUtils.makeGet(`providers/${vm.currentProvider.id}/history/items`, {
                    term: vm.search,
                    medical_history_category_id: vm.medicalHistoryCategoryId
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error consultando antecedentes')
                    return
                }

                const json = await response.json()
                vm.historyItems = json.result.items.data

               vm.$nextTick(function(){
                   if(vm.value){
                       vm.model = vm.value
                   }
               })

            }
        },
        computed: {
            ...mapState(['currentProvider']),
            shouldCreate(){
                return this.search && this.historyItems.length === 0 && (!this.model || typeof this.model === 'string') && !this.loading
            },
            items () {
                return this.historyItems.map(reason => {
                    return {
                        id: reason.id,
                        title: reason.description,
                    }
                })
            }
        },
        watch: {
            search (val) {
                var vm = this
                if(vm.model && val === vm.model.title) return
                vm.model = null
                vm.debouncegetItems()
            },
            value(val){
                this.model = val
            },
            model(val){
                const vm = this
                const newModel = typeof val === 'string' ? null : val
                vm.$emit('change', newModel)
                if(val){
                  vm.$nextTick(() => {
                    vm.clearSearch()
                  })
                }
            }
        }
    }
</script>

<style scoped>
  >>>.v-input__control {
    background-color: var(--v-secondary-card-base) !important;
  }
</style>
